<template>
  <component
    :is="tag"
    role="main"
    :class="{'container': disableClassContainer }">
    <slot />
  </component>
</template>

<script>
// @flow
export default {
  name: 'SmartContainer',
  props: {
    tag: {
      type: String,
      default: 'section'
    },
    disableClassContainer: {
      type: Boolean,
      default: true,
    }
  }
};
</script>
